import axios from 'axios';

// Base URL configuration
const getBaseURL = () => {
  const apiUrl = import.meta.env.VITE_API_BASE_URL || 'http://localhost:6969';
  
  // console.log('Environment variables:', {
  //   VITE_API_BASE_URL: import.meta.env.VITE_API_BASE_URL,
  //   DEV: import.meta.env.DEV,
  //   MODE: import.meta.env.MODE
  // });
  
  // Always use the direct API URL for now (bypass proxy)
  // console.log('Using direct API URL:', apiUrl);
  return apiUrl;
};

// Create axios instance with base configuration
const baseURL = getBaseURL();
// console.log('Creating axios instance with baseURL:', baseURL);

const api = axios.create({
  baseURL: baseURL,
  withCredentials: false, // Set to false for local development, true for production with same domain
  headers: {
    'Content-Type': 'application/json',
  },
  timeout: parseInt(import.meta.env.VITE_API_TIMEOUT) || 10000, // Use environment timeout or default to 10 seconds
});

// Request interceptor to add auth token
api.interceptors.request.use(
  (config) => {
    // console.log('Making API request:', {
    //   method: config.method?.toUpperCase(),
    //   url: config.url,
    //   baseURL: config.baseURL,
    //   fullURL: `${config.baseURL || ''}${config.url}`
    // });
    
    const token = localStorage.getItem('token');
    // console.log('Request interceptor - Token from localStorage:', token);
    
    if (token) {
      // Backend expects token directly in authorization header, not "Bearer " prefix
      config.headers.authorization = token;
      // console.log('Added authorization header (without Bearer):', config.headers.authorization);
    } else {
      // console.log('No token found in localStorage');
    }
    
    return config;
  },
  (error) => {
    // console.error('Request interceptor error:', error);
    return Promise.reject(error);
  }
);

// Response interceptor to handle common errors
api.interceptors.response.use(
  (response) => {
    // console.log('API Response:', {
    //   url: response.config.url,
    //   status: response.status,
    //   data: response.data
    // });
    return response;
  },
  (error) => {
    // console.error('API Error:', {
    //   url: error.config?.url,
    //   status: error.response?.status,
    //   message: error.message,
    //   data: error.response?.data
    // });
    
    // Handle unauthorized errors
    if (error.response?.status === 401) {
      // console.log('401 Unauthorized - clearing auth data');
      localStorage.removeItem('token');
      localStorage.removeItem('user');
      
      // Only redirect if not already on login page
      if (!window.location.pathname.includes('/auth/login')) {
        // console.log('Redirecting to login page');
        window.location.href = '/auth/login';
      }
    }
    
    // Handle network errors
    if (!error.response) {
      // console.error('Network Error:', error.message);
    }
    
    return Promise.reject(error);
  }
);

export default api;